import { CHECKOUT_DROP_IN_ENVIRONMENT_FOR_URL_ROOTS, CheckoutDropInEnvironment } from '@platform-frontend/checkout-drop-in';
import { map, Observable } from 'rxjs';
import { PlatformEnvironmentName } from './platform-environment-name';
import { PLATFORM_ENVIRONMENT_BACKEND_API_ROOT, PLATFORM_ENVIRONMENT_NAME, PLATFORM_ENVIRONMENT_ROOT } from './platform-environment-specifics';

export interface PlatformEnvironment extends CheckoutDropInEnvironment {
  accountUrl: (locale$: Observable<string>) => Observable<string>;
  isDemo: boolean;
  isDevelopment: boolean;
  isProduction: boolean;
  isTest: boolean;
  name: PlatformEnvironmentName;
  rootUrl: string;
  apiRootUrl: string;
  solutionPortalUrl: (locale$: Observable<string>, subPath?: string) => Observable<string>;
}

export const TEST_MATOMO_SITE_ID: string = '9';

export const PLATFORM_ENVIRONMENT: PlatformEnvironment = {
  ...CHECKOUT_DROP_IN_ENVIRONMENT_FOR_URL_ROOTS(PLATFORM_ENVIRONMENT_ROOT, PLATFORM_ENVIRONMENT_BACKEND_API_ROOT),
  accountUrl: (locale$: Observable<string>) => locale$.pipe(map(locale => PLATFORM_ENVIRONMENT_ROOT + '/account?locale=' + locale)),
  isDemo: PLATFORM_ENVIRONMENT_NAME === 'SHOWCASE',
  isDevelopment: PLATFORM_ENVIRONMENT_NAME === 'DEV',
  isProduction: PLATFORM_ENVIRONMENT_NAME === 'PRODUCTION',
  isTest: PLATFORM_ENVIRONMENT_NAME === 'STAGE' || PLATFORM_ENVIRONMENT_NAME === 'PREVIEW',
  name: PLATFORM_ENVIRONMENT_NAME,
  solutionPortalUrl: (locale$: Observable<string>, subPath: string = '') =>
    locale$.pipe(map(locale => PLATFORM_ENVIRONMENT_ROOT + '/portal' + subPath + '?locale=' + locale)),
  rootUrl: PLATFORM_ENVIRONMENT_ROOT,
  apiRootUrl:PLATFORM_ENVIRONMENT_BACKEND_API_ROOT
};
